import styled, { css } from 'styled-components'
import { opacify } from 'polished'

import { color, transition, typography, Media, placeholder } from '../style'
import Wrapper from './wrapper'

export const BannerContainer = styled.div`
  position: relative;
  height: ${(p) => `${p.height || 720}px`};
  z-index: 0;
  h1 {
    color: white;
    line-height: 1;
    font-size: ${typography.h1};
  }
  p {
    font-size: ${typography.h4};
    color: white;
    max-width: 380px;
  }
  ${Media.lessThan(Media.small)} {
    height: ${(p) => `${p.mobileHeight || 360}px`};
    h1 {
      font-size: 36px;
    }
    button {
      height: 36px;
      line-height: 36px;
      width: 140px;
    }
  }
`
export const BannerWrapper = styled(Wrapper)`
  ${Media.lessThan(Media.small)} {
    height: ${(p) => p.$fromPaas && `${p.mobileHeight}px`};
  }
  height: ${(p) => (p.$fromPaas ? `${p.PCHeight}px` : '100%')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`
export const Section = styled.section`
  position: relative;
  overflow: hidden;
  padding: 60px 0;
  ${Media.lessThan(Media.small)} {
    padding: 20px 0;
  }
`
export const GreySection = styled(Section)`
  background-color: ${(p) => (p.$fromPaas ? opacify('-0.6', color.grey) : color.grey)};
  ${Media.lessThan(Media.small)} {
    padding: ${(p) => p.$fromPaas && p.mobilePadding};
  }
  padding: ${(p) => p.$fromPaas && p.PCPadding};
`
export const DarkSection = styled(Section)`
  background-color: ${color.background};
`
export const Title = styled.h2`
  color: white;
  text-align: center;
  font-size: ${typography.h2};
  line-height: 3;
  ${Media.lessThan(Media.small)} {
    font-size: ${typography.h3};
  }
`
export const Emphasis = styled.em`
  color: ${color.primary};
  font-style: normal;
`
export const H3 = styled.h3`
  margin: 0;
  line-height: 3;
  color: white;
  font-size: ${typography.h3};
`
export const H4 = styled.h4`
  margin: 0;
  line-height: 3;
  color: ${color.text};
  font-size: ${typography.h4};
`
export const Prompt = styled.span`
  color: ${color.textDark};
  font-size: ${typography.textSmall};
`
export const Paragraph = styled.p`
  margin: 0;
  color: ${color.text};
  font-size: ${typography.textSmall};
`
const InputStyle = css`
  ${placeholder(color.textLight)}
  position: relative;
  display: inline-block;
  width: ${(p) => p.width || '200px'};
  padding: 0 1em;
  height: ${(p) => p.height || '40px'};
  line-height: ${(p) => p.height || '40px'};
  border-radius: 5px;
  background-color: ${color.panel};
  background-image: none;
  border: 1px solid ${color.border};
  color: ${color.text};
  transition: ${transition('border-color')};
  :not([disabled]):focus {
    outline: 0;
  }
  :hover {
    border-color: ${color.textLight};
  }
`
export const Input = styled.input`
  ${InputStyle};
`
export const Textarea = styled.textarea`
  ${InputStyle};
  resize: none;
  height: 90px;
  line-height: 1.5;
  padding: 1em;
`
